import { createApp } from 'vue'
import App from './App.vue'
import router from '@/plugins/router.ts'
import { vuetify } from '@/plugins/vuetify.ts'
import './style/main.css'
import globals from "@/plugins/globals.ts";
import auth from "@/plugins/auth.ts";
import messages from "@/plugins/messages.ts";

const app = createApp(App)

app.use(globals)
app.use(auth)
app.use(messages)
app.use(router)
app.use(vuetify)

app.mount('#app')